<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">线索管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">分配记录</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- 日期 -->
                <a-range-picker :locale="locale" @change="ondateChange" placeholder="请选择日期范围"/>
                <!-- 坐席 -->
                <a-select style="width: 120px;margin-left:12px" allowClear @change="userhandleChange" placeholder="坐席" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in useroption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>

                <!-- 通话时长 -->
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="usxsfpid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
    
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="video" >
                        <!-- <video :src="text"></video> -->
                    </span>

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>


    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
const columns = [
    {title: 'ID',dataIndex: 'usxsfpid',key: 'usxsfpid',width:80},
    {title: '线索ID',dataIndex: 'usxsid',key: 'usxsid',width:80},
    {title: '客户姓名',dataIndex: 'username_userxs',key: 'username_userxs',width:90},
    {title: '号码',dataIndex: 'telephone_userxs',key: 'telephone_userxs',width:120},
    {title: '坐席姓名',dataIndex: 'username_kf',key: 'username_kf',width:120},
    {title: '管理员',dataIndex: 'username_admin',key: 'username_admin',width:120},
    {title: '分配时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' },width:120},
]
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            useroption:[{id:1,name:'坐席1'}],
            locale,

            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,

            tablex:''
        }
    },
    // watch: {
    //   windowHeight (val) {
    //     this.tablex=val-300
    //   },
    // },
    mounted(){
        this.fetch()

        // window.fullWidth = document.documentElement.clientWidth;
        // this.windowWidth = window.fullWidth;  
        // this.tablex=this.windowWidth-300
        // window.onresize = () => {
        //     return (() => {
        //         window.fullWidth = document.documentElement.clientWidth;
        //         this.windowWidth = window.fullWidth;  // 高
        //         this.tablex=this.windowWidth-300
        //     })()
        // };
    },
    methods:{

        // 日期范围
        ondateChange(e){

        },
        // 选择坐席
        userhandleChange(){

        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/user/userxsfplog',{
                pagesize: this.size,
                page:this.currentpage,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/cluelog/fplog.vue